<template>
  <v-page no-padding white>
    <div class="h-100 bg-white">
      <thread-header
        is-new
        :user="subscriber"
        :parent-message="parentMessage"
      />

      <template v-if="isLoading">
        <thread-placeholder class="mb-1" />
      </template>
      <template v-else>
        <thread-prompt
          :icon="parentMessage ? 'reply' : 'forum'"
          :heading="promptHeading"
          :description="promptDescription"
          :padding-top="!!parentMessage ? '7.5vh' : '15vh'"
        />
      </template>

      <div class="container">
        <div :class="[{ 'ml-3': !!parentMessage }]">
          <thread-footer
            :is-thread="!!parentMessage"
            :is-comment-thread="!!parentMessage"
          >
            <message-compose
              :is-loading="isLoading || isCreating"
              :placeholder="
                parentMessage ? 'Add your reply' : 'Write something...'
              "
              @submit="handleSubmit"
            />
          </thread-footer>
        </div>
      </div>
    </div>
  </v-page>
</template>

<script>
import { mapActions } from "vuex"

import { isPresent } from "@/lib/utils"
import EventBus, { EVENTS } from "@/lib/event-bus"
import { parseMessageId } from "@/lib/messages-utils"

import ThreadPrompt from "@/components/message-thread/Prompt"
import ThreadFooter from "@/components/message-thread/Footer"
import MessageCompose from "@/components/message-thread/MessageCompose"
import ThreadHeader from "@/components/message-thread/Header"
import ThreadPlaceholder from "@/components/message-thread/ThreadPlaceholder"

export default {
  components: {
    ThreadPrompt,
    ThreadFooter,
    ThreadHeader,
    MessageCompose,
    ThreadPlaceholder
  },

  data() {
    return {
      isLoading: false,
      isCreating: false,
      subscriber: null,
      parentMessage: null
    }
  },

  computed: {
    promptHeading() {
      if (this.subscriber) {
        return "Send your message"
      } else {
        return `Reply to ${this.parentMessage?.user?.name}`
      }
    },

    promptDescription() {
      if (this.subscriber) {
        return `Send a message to start your conversation with ${this.subscriber?.name}`
      } else {
        return `Write a message to start a thread`
      }
    }
  },

  activated() {
    this.initializeForm()
  },

  deactivated() {
    this.subscriber = null
    this.parentMessage = null
  },

  mounted() {
    this.initializeForm()
  },

  methods: {
    isPresent,

    ...mapActions("messages", [
      "fetchSubscriber",
      "fetchMessage",
      "createMessageThread"
    ]),

    initializeForm() {
      this.isLoading = true

      if (this.$route.query.user) {
        this.fetchSubscriber(this.$route.query.user)
          .then(subscriber => {
            this.subscriber = subscriber
          })
          .finally(() => {
            this.isLoading = false
          })
      } else if (this.$route.query.message) {
        const [messageThreadId, messageTs] = parseMessageId(
          this.$route.query.message
        )

        this.fetchMessage({
          messageThreadId,
          messageTs
        })
          .then(message => {
            this.parentMessage = message
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$router.replace("/me/messages")
      }
    },

    handleSubmit(messages) {
      this.isCreating = true

      this.createMessageThread({
        subscriberId: this.subscriber?.id,
        parentMessage: this.parentMessage,
        messages
      })
        .then(messageThread => {
          this.$router.replace(
            `/me/messages/${messageThread.id}?focus=true&reply=true`
          )

          setTimeout(() => {
            EventBus.$emit(EVENTS.PROMPT_PUSH_PERMISSION)
          }, 500)
        })
        .catch(err => {
          this.$notify(err.response.data.message)
        })
        .finally(() => {
          this.isCreating = false
        })
    }
  }
}
</script>
